// @core/api/endpoints/bootstrap/save_security_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SaveSecurityConfigRequest,
  SaveSecurityConfigResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Save security configuration
 * Saves authentication methods (local, LDAP, SAML, OIDC), security policies, and JWT configuration. LDAP/OIDC credentials are stored in the secret service during execution.
 * @public This endpoint does not require authentication
 */
export async function SaveSecurityConfig(
  data: SaveSecurityConfigRequest,
  options?: RequestOptions
): Promise<SaveSecurityConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/steps/security`;
  const requestOptions = { ...options, skipAuth: true };
  return client.put<SaveSecurityConfigResponse>(requestPath, data, requestOptions);
}
